import config from '@/assets/config'
import { getFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s6ScrollD = config.scenesScrollD[5]
const s6ScrollT = config.scenesScrollT[5]

// 旋转缩放
const s6RotateD = s6ScrollD
const s6RotateT = s6ScrollT * 0.1
const s6StaticH = wh
const s6StaticW = wh * 3800 / 2436
const s6StaticH2 = s6StaticH * 1.5
const s6StaticW2 = s6StaticW * 1.5

// 平移
const s6MoveD = s6RotateD + s6RotateT // 0.1T
const s6MoveT = s6ScrollT * 0.3
const s6StaticScrollW = s6StaticW - ww

// 我
const s6Me1L = 2928 / 3800 * s6StaticW
const s6Me2L = 3182 / 3800 * s6StaticW
const s6MeFadeD = s6MoveD + s6MoveT // 0.4T
const s6MeFadeT = s6ScrollT * 0.1

// 对话
const s6Talk1D = s6MeFadeD + s6MeFadeT // 0.5T
const s6Talk1T = s6ScrollT * 0.1
const s6Talk1H = wh * 0.322
const s6Talk1W = s6Talk1H * 222 / 784
const s6TalkL = 3324 / 3800 * s6StaticW

// 文字
const s6TextD = s6Talk1D + s6Talk1T // 0.6T
const s6TextT = s6ScrollT * 0.05
const s6TextL = (1 - (ww * 0.94) / s6StaticW) * s6StaticW

// 红点
const s6RedD = s6TextD + s6TextT + s6ScrollT * 0.34 // 0.9T
const s6RedT = s6ScrollT * 0.06
const s6RedD2 = s6RedD + s6RedT

const animations = {
  s6_static: [
    {
      delay: s6RedD,
      duration: s6RedT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s6RotateD,
      duration: s6RotateT,
      from: { rotation: 0.3 * Math.PI, alpha: 0, y: wh * 2.5, width: s6StaticW2, height: s6StaticH2 },
      to: { rotation: 0, alpha: 1, ease: 'ease', y: wh * 2, width: s6StaticW, height: s6StaticH }
    },
    {
      delay: s6MoveD,
      duration: s6MoveT,
      from: { x: 0 },
      to: { x: -s6StaticScrollW }
    }
  ],
  s6_me1: [
    {
      delay: s6MoveD,
      duration: s6MoveT,
      from: { x: s6Me1L },
      to: { x: s6Me1L - s6StaticScrollW }
    },
    {
      delay: s6MeFadeD,
      duration: s6MeFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    }
  ],
  s6_me2: [
    {
      delay: s6RedD,
      duration: s6RedT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s6MoveD,
      duration: s6MoveT,
      from: { x: s6Me2L },
      to: { x: s6Me2L - s6StaticScrollW }
    },
    {
      delay: s6MeFadeD,
      duration: s6MeFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s6_talk1: [
    {
      delay: s6RedD,
      duration: s6RedT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s6MoveD,
      duration: s6MoveT,
      from: { x: s6TalkL },
      to: { x: s6TalkL - s6StaticScrollW }
    },
    {
      delay: s6Talk1D,
      duration: s6Talk1T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s6Talk1W, height: s6Talk1H, ease: 'ease' }
    }
  ],
  s6_text: [
    {
      delay: s6RedD,
      duration: s6RedT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s6MoveD,
      duration: s6MoveT,
      from: { x: s6TextL },
      to: { x: s6TextL - s6StaticScrollW }
    },
    {
      delay: s6TextD,
      duration: s6TextT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s6_red: [
    {
      delay: s6RedD2,
      duration: s6RedT * 0.01,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s6RedD,
      duration: s6RedT * 0.01,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s6RedD,
      duration: s6RedT,
      frames: getFrames('s6_red', 13, 1)
    }
  ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s6/spritesAnimations.js